document.addEventListener("DOMContentLoaded", function () {
  // PANEL BUTTON LOGIC
  const panelButton = document.getElementById("order-panel-button");
  let panelCartUrl = "";
  if (panelButton) {
    panelCartUrl = panelButton.href;
    panelButton.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopImmediatePropagation(); // Stop other click handlers
      const modal = document.getElementById("contactInfoModal");
      if (modal) {
        modal.style.display = "block";
      }
    }, true); // Attach in capture phase
  }

  // MODAL CLOSE LOGIC
  document.addEventListener("click", function (event) {
    const modal = document.getElementById("contactInfoModal");
    if (modal && event.target === modal) {
      modal.style.display = "none";
    }
  });
  const closeButton = document.querySelector("#contactInfoModal .close");
  if (closeButton) {
    closeButton.addEventListener("click", function () {
      const modal = document.getElementById("contactInfoModal");
      if (modal) {
        modal.style.display = "none";
      }
    }, true);
  }

  // FORM SUBMISSION LOGIC
  const form = document.getElementById("contactForm");
  if (form) {
    // Attach our submit handler in capture mode so it runs before others
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      e.stopImmediatePropagation(); // Prevent any other submit listeners

      console.log("Form submit event triggered");

      // Gather form field values
      const firstName = document.getElementById("first_name").value;
      const lastName = document.getElementById("last_name").value;
      const email = document.getElementById("email").value;
      const companyName = document.getElementById("company_name").value;
      const city = document.getElementById("city").value;
      const industryType = document.getElementById("industry_type").value;
      const applicationProcess = document.getElementById("application_process").value;
      const currentSupplier = document.getElementById("current_supplier").value;
      const additionalComments = document.getElementById("additional_comments").value;
      const marketingConsent = document.getElementById("marketing_consent").checked ? "true" : "false";
      const shopifyInterestFormSource = "Yes";

      // Default values for eliminated fields
      const country = "United States";
      const coatingType = "Powder";

      // Log document.cookie to check for hubspotutk
      console.log("document.cookie:", document.cookie);

      // Extract the hubspotutk cookie value using regex
      const match = document.cookie.match(/(?:^|;\s*)hubspotutk=([^;]+)/);
      const hutkValue = match ? match[1].trim() : "";
      console.log("Extracted hutkValue:", hutkValue);

      // Build the context object
      const contextData = {
        pageUri: window.location.href,
        pageName: document.title
      };

      // Only add hutk if it's non-empty; if empty, omit it.
      if (hutkValue.length > 0) {
        contextData.hutk = hutkValue;
      }
      console.log("contextData:", contextData);

      // Construct the payload for HubSpot
      const payload = {
        fields: [
          { name: "firstname", value: firstName },
          { name: "lastname", value: lastName },
          { name: "email", value: email },
          { name: "company", value: companyName },
          { name: "city", value: city },
          { name: "country", value: country },
          { name: "core_segment", value: industryType },
          { name: "what_is_your_application_process_and_end_use_", value: applicationProcess },
          { name: "who_is_your_current_supplier__v2__interest_form_", value: currentSupplier },
          { name: "additional_comments", value: additionalComments },
          { name: "type_of_coating_", value: coatingType },
          { name: "i_would_like_to_receive_future_updates_about_your_products_", value: marketingConsent },
          { name: "ic_interest_form_submitted_via_shopify_site", value: shopifyInterestFormSource }
        ],
        context: contextData
      };

      console.log("Payload:", payload);
      console.log("This is proof the console logging is working");

      // Send the payload to HubSpot's submission endpoint
      fetch("https://api.hsforms.com/submissions/v3/integration/submit/540259/aa30d1e6-891b-47a0-80e4-1093b56c91ea", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(payload)
      })
        .then(response => {
          if (response.ok) {
            alert("Thank you for the information!");
            const modal = document.getElementById("contactInfoModal");
            if (modal) {
              modal.style.display = "none";
            }
            form.reset();
            window.location.href = panelCartUrl;
          } else {
            return response.json().then(data => {
              throw new Error(data.errors ? data.errors.map(e => e.message).join(", ") : "Submission error");
            });
          }
        })
        .catch(error => {
          console.error("Error submitting form:", error);
          alert("There was an error submitting your form. Please try again later.");
        });
    }, true); // Attach in capture phase
  }
});
